import React from 'react';
import Lottie from 'react-lottie';
import './Location_lottie.css';
import * as animationData from './Location_lottie.json';

const Location_lottie = () => {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    return (
        <>
            <section className='main'>
                <div className='Location_lottie_icon'>
                    <Lottie className="me-auto"
                        options={defaultOptions}
                    // height={60}
                    // width={60}          
                    />
                </div>
            </section>
        </>
    )
}

export default Location_lottie
